import React, { FC, useState } from 'react';

import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';

import LoadingButton from '~/components/atoms/buttons/LoadingButton';

import styles from './styles.module.scss';

type Props = {
  onClick: () => Promise<void>;
};

const ButtonIcon: FC = () => (
  <Icon icon="material-symbols:bolt-outline" color="#FFE86C" />
);

const UpgradeNowButton: FC<Props> = ({ onClick }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async (): Promise<void> => {
    try {
      setIsLoading(true);
      await onClick();
    } catch (e) {
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <LoadingButton
      disabled={isLoading}
      loading={isLoading}
      fullWidth
      startIcon={<ButtonIcon />}
      onClick={handleClick}
      className={styles.button}
    >
      {t('upgrade_now', 'Upgrade Now')}
    </LoadingButton>
  );
};

export default UpgradeNowButton;
